import React from 'react'
import { NoResults } from '../NoResults'

type InformationalEmptyStateProps = {
  title: string
  note: string
  margin?: string
}

export const InformationalEmptyState = ({
  title,
  note,
  margin,
}: InformationalEmptyStateProps): JSX.Element => {
  return <NoResults title={title} note={note} margin={margin} />
}
